export default __webpack_public_path__ + "static/hram-ikony-bozhiej-materi-sporitelnica-hlebov-krovlya_5-28bdd7b9418120c6288e33077f2910b5.jpg";